import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import SmartImage from './SmartImage';
import api, { mediaUrl } from '../lib/api';

const fmtDate = (p) => {
  const raw = p.published_at || p.created_at || p.date;
  if (!raw) return null;
  try { return new Date(raw).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }); } catch { return null; }
};

const FeaturedBlog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get('/home/blog')
      .then((res) => setPosts((res.data || []).slice(0, 8)))
      .catch(() => setPosts([]));
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="news" className="py-20 md:py-28 bg-cream-2/40" data-testid="home-featured-blog">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-8 rounded-full flex items-center justify-center bg-rose-soft"><span className="w-3 h-3 rounded-full bg-mahogany" /></span>
              <span className="eyebrow">News &amp; Blogs</span>
            </div>
            <h2 className="font-serif-display text-burgundy text-4xl md:text-6xl leading-[1.05]">Words from <span className="font-italic-display text-rose-italic">the Path</span></h2>
          </div>
          <Link to="/blog" className="pill-btn-outline self-start md:self-auto" data-testid="home-blog-viewall">View all posts <ArrowUpRight className="w-4 h-4" /></Link>
        </div>

        <div className="divide-y divide-rose/25 border-y border-rose/25" data-testid="home-blog-list">
          {posts.map((p, i) => {
            const date = fmtDate(p);
            return (
              <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`home-blog-${p.slug}`}
                className="group grid grid-cols-[auto_1fr_auto] items-center gap-4 md:gap-6 py-5 md:py-6 fade-up hover:bg-white/50 -mx-4 px-4 rounded-2xl transition-colors"
                style={{ animationDelay: `${i * 70}ms` }}>
                <SmartImage src={mediaUrl(p.cover_image)} alt={p.title} className="w-16 h-16 md:w-20 md:h-20 rounded-2xl overflow-hidden shrink-0" />
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] uppercase tracking-widest text-mahogany/55 mb-1">
                    {p.category && <span className="text-mahogany/80">{p.category}</span>}
                    {p.category && date && <span className="text-rose/70">·</span>}
                    {date && <span>{date}</span>}
                    {p.author && <><span className="text-rose/70">·</span><span className="normal-case tracking-normal text-mahogany/50">{p.author}</span></>}
                  </div>
                  <h3 className="font-serif-display text-burgundy text-xl md:text-2xl leading-snug group-hover:text-rose-italic transition-colors truncate">{p.title}</h3>
                  {p.excerpt && <p className="text-sm text-burgundy/70 line-clamp-1 md:line-clamp-2 mt-1">{p.excerpt}</p>}
                </div>
                <span className="hidden sm:inline-flex items-center gap-1.5 text-mahogany font-medium text-sm whitespace-nowrap">Continue reading <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturedBlog;
